import Polyglot from "node-polyglot";
import loadAdditional from "./lib/loadAdditionalTranslations";
import en from "./locales/en-us.yaml";
import { LanguageKey } from "./types";

if (process.env.NODE_ENV === "development") {
  const nonStringValues = Object.values(en).filter(
    (x) => typeof x !== "string"
  );

  if (nonStringValues.length) {
    console.error(
      "All en-us.yaml values *must* be a string. See: en-us.yaml",
      nonStringValues
    );
  }
}
const currentLocale =
  (localStorage.getItem("language") as LanguageKey) ||
  (navigator.language.toLowerCase() as LanguageKey) ||
  LanguageKey["en-us"];

const polyglot = new Polyglot({
  locale: currentLocale,
  allowMissing: true,
});

polyglot.extend(en);

const t = (
  key: string | { key: string; data: any } = "",
  interpolationOptions?: Polyglot.InterpolationOptions
) => {
  if (typeof key === "object") {
    return polyglot.t(key.key, key.data);
  }
  if (!polyglot.has(key) && interpolationOptions?.fallback) {
    return polyglot.t(interpolationOptions.fallback, interpolationOptions);
  }

  const translatedString = polyglot.t(key, interpolationOptions);

  if (process.env.DEBUG_I18N) {
    return `❗${translatedString}❗`;
  }

  return translatedString;
};

const i18n = {
  t: t.bind(polyglot),
  extend: polyglot.extend.bind(polyglot),
  currentLocale,
};

export const loadAdditionalTranslations = loadAdditional(i18n);

export default i18n;

export const language = currentLocale;
